export const DATA_HOOKS = {
  ITEM_TEXT: 'vertical-tabs-item-text',
  ITEM_PREFIX_ICON: 'vertical-tabs-item-prefix-icon',
  ITEM_SUFFIX_ICON: 'vertical-tabs-item-suffix-icon',
} as const;
